<script setup>
import { defineVaDataTableColumns, VaDataTable, VaPagination, VaBadge, VaModal, VaCard, VaCardContent, VaButton } from 'vuestic-ui';
import { computed, ref } from 'vue';

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
})

const currentPage = ref(1);
const perPage = ref(20);
const showModal = ref(false);
const selectedTitular = ref(null);

// Filtramos apenas os titulares para a tabela principal
const titularItems = computed(() => {
  return props.data;
});

// Filtramos os dependentes do titular selecionado
const dependentsOfSelectedTitular = computed(() => {
  if (!selectedTitular.value) return [];
  return props.data.filter(item => item.parent_customer_id === selectedTitular.value.id);
});

const pages = computed(() => {
  return Math.ceil(titularItems.value.length / perPage.value);
});

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * perPage.value;
  const end = start + perPage.value;
  return titularItems.value.slice(start, end);
});

const columns = defineVaDataTableColumns([
  { label: 'Nome', key: 'name', sortable: true },
  { label: 'E-mail', key: 'email', sortable: true },
  { label: 'Telefone', key: 'phone', sortable: true },
  { label: 'CPF', key: 'cpf', sortable: true },
  { label: 'Tipo', key: 'type' },
  { label: 'Plano', key: 'plan' },
  { label: 'Data de Cadastro', key: 'created_at', sortable: true },
])

const dependentColumns = defineVaDataTableColumns([
  { label: 'Nome', key: 'name' },
  { label: 'E-mail', key: 'email' },
  { label: 'CPF', key: 'cpf' },
  { label: 'Data de Cadastro', key: 'created_at' },
])

function formatDate(dateString) {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

function onRowClick(row) {
  const item = row.item || row;
  if (item && item.dependents_count > 0) {
    selectedTitular.value = item;
    showModal.value = true;
  }
}
</script>

<template>
  <div>
    <VaDataTable
      clickable
      hoverable
      :items="paginatedItems"
      :columns="columns"
      @row:click="onRowClick"
    >
      <template #cell(name)="{ rowData }">
        <div class="flex items-center gap-1">
            <span class="font-bold">{{ rowData.name }}</span>
            <span v-if="rowData.dependents_count > 0" class="text-primary font-bold">
                ({{ rowData.dependents_count }})
            </span>
        </div>
      </template>

      <template #cell(type)="{ rowData }">
        <VaBadge
          :text="rowData.parent_customer_id ? 'Dependente' : 'Titular'"
          :color="rowData.parent_customer_id ? 'info' : 'success'"
        />
      </template>

      <template #cell(plan)="{ rowData }">
        <VaBadge
          :text="rowData.can_have_dependents === true || rowData.can_have_dependents == 1 ? 'Plano Corporativo' : 'Plano Básico'"
          :color="rowData.can_have_dependents === true || rowData.can_have_dependents == 1 ? 'info' : 'success'"
        />
      </template>

      <template #cell(created_at)="{ rowData }">
        {{ formatDate(rowData.created_at) }}
      </template>
    </VaDataTable>

    <div v-if="pages > 1" class="flex justify-center mt-4">
        <VaPagination v-model="currentPage" :pages="pages" :visible-pages="5" />
    </div>

    <VaModal
      v-model="showModal"
      hide-default-actions
      size="large"
      :title="`Dependentes de ${selectedTitular?.name}`"
    >
      <VaCard outlined>
        <VaCardContent>
          <VaDataTable
            :items="dependentsOfSelectedTitular"
            :columns="dependentColumns"
          >
            <template #cell(created_at)="{ rowData }">
              {{ formatDate(rowData.created_at) }}
            </template>
          </VaDataTable>
        </VaCardContent>
      </VaCard>
      <template #footer>
        <VaButton @click="showModal = false"> Fechar </VaButton>
      </template>
    </VaModal>
  </div>
</template>

<style scoped>
:deep(.va-data-table__table-tr--clickable) {
  cursor: pointer;
}
</style>
